import { LogInfoProps } from './logInfo'

export interface ViewerHealthInsurance {
    id: number
    name: string
    number: string
    ans: string
}

export type LogoutResponse = {
    status: string
} | null

export type LogoutData = {
    logoutAccount: {
        status: string
    }
}

export interface AuthenticationPayload {
    accessToken: string
    refreshToken: string
    userId: number
    uuid?: string
}

export interface TokenPayload {
    token: string | undefined
    refreshToken: string | undefined
    limitedFlow?: boolean
    redesign?: boolean
    selfLogin?: boolean
    keepLogged?: {
        keepLogged?: boolean | null
        latitude?: string | null
        longitude?: string | null
        address?: string | null
        uuid?: string | null
        patientId?: number | null
        token?: string
        refreshToken?: string
        username?: string
    }
}

export interface KeepLoggedPayload {
    token: string | null
    refreshToken: string | null
    keepLogged?: {
        keepLogged?: boolean | null
        latitude?: string | null
        longitude?: string | null
        address?: string | null
        uuid?: string | null
        patientId?: number | null
        token?: string
        refreshToken?: string
        username?: string
    }
}

export interface UserResponse {
    viewer: User
}

export interface AuthState {
    token: string | null
    refreshToken: string | null
    signed: boolean
    limitedFlow: boolean
    user: User | null
    redesign?: boolean
    keepLogged?: {
        keepLogged?: boolean
        latitude?: string
        longitude?: string
        address?: string
        uuid?: string
        patientId?: number
        token?: string
        refreshToken?: string
        username?: string
    }
}

export interface ModalForgotPasswordData {
    title: string
    subtitle: string
    itens: Array<{
        icon: React.ReactElement
        title: string
        subtitle: string
        type: string
    }>
}

export interface SignInCredentials {
    username: string
    password: string
    recaptchaToken: string | null
    keepLogged?: {
        keepLogged?: boolean | null
        latitude?: string | null
        longitude?: string | null
        address?: string | null
        patientId?: number | null
        uuid?: string | null
    }
    logInfo?: LogInfoProps
}

export interface SignInCIPCredentials {
    cip: string
    password: string
    dateOfBirth: string
    lab: string
    recaptchaToken: string | null
    isInvalid: boolean
}

export interface PersonalDataSignUpData {
    username: string
    cpf: string
    birthDate: string
}

export interface LocationState {
    status?: string
    message?: string
}

export interface AuthenticateData {
    authenticateWithReCaptcha: {
        access_token: string
        refresh_token: string
        uuid: string
    }
}

export interface AuthenticateCIPData {
    authenticateCIPWithReCaptcha: {
        accessToken: string
    }
}

export interface RefreshAuthenticateData {
    refreshToken: {
        access_token: string
        refresh_token: string
    }
}

export interface RefreshTokenAuthenticate {
    token: string
}

export enum LoginType {
    cip = 'cip',
    cpf = 'cpf',
    empty = 'empty',
}

export interface Lab {
    name: string
    title: string
    status: string
    group: string
}

export type IntegratedAuthToken = {
    authenticateHash: {
        accessToken: string
        refreshToken: string
        type: string
    }
}

export type IntegratedAuthTokenResponse = {
    accessToken: string
    refreshToken: string
    type: string
} | null

export type GenerateUniqueTokenData = {
    generateUniqueToken: {
        token: string
    }
}

export type AuthenticateWithUniqueTokenData = {
    authenticateUniqueToken: {
        accessToken: string
        refreshToken: string
    }
}

export type AuthenticateWithUniqueTokenResponse = {
    accessToken: string
    refreshToken: string
} | null

export interface User {
    id?: number
    name?: string
    underage: boolean
    loginNav?: boolean
    limitedFlow?: boolean
    federalTaxId?: string
    birthDate?: string
    tokenType?: string
    isInvalid?: boolean
}

export interface GenerateUniqueTokenProps {
    accessToken: string
    refreshToken: string
}

export interface GenerateUniqueResponse {
    token: string
}

export type ViewerFeatureFlag = {
    key: string
    value: boolean | string | number
}

export type ViewerFeatureFlags = {
    featureFlags: ViewerFeatureFlag[]
}

export type handleAuthUserAfterChangePasswordProps = {
    cpf: string
    password: string
}

export type UserToken = {
    token: string
    refreshToken: string
    keepLogged?: {
        keepLogged?: boolean | null
        latitude?: string | null
        longitude?: string | null
        address?: string | null
        uuid?: string | null
        patientId?: number | null
        username?: number | null
    }
}

export type RefreshTokens = {
    access_token: string | null | undefined
    refresh_token: string | null | undefined
}

export type RefreshTokenResponse = {
    refreshToken: RefreshTokens
}

export type CurrentLaboratoryType = {
    layoutType: string
    name: string
    titleBgColor: string
    layout: string
    image: string
    numberOfItems?: number
}

export type GetMagicLinkByIdType = {
    patientName: string
    isUsed: boolean
    isAttemptLimitExceeded: boolean
    isExpired: boolean
    createdAt: string
}
